// Route guard that gates a subtree on a specific module flag. If the
// currently-authed client doesn't have access, we render the friendly
// locked page in place instead of forwarding the user away — that
// matches the spec where the sidebar entry stays visible (with a lock
// icon) and clicking it lands here.
import { useAuthStore } from "@/stores/auth"
import { hasModuleAccess, type ModuleKey } from "@/lib/module-access"
import ModuleLockedPage from "@/pages/client/ModuleLocked"

export function ModuleGuard({
  module,
  children,
}: {
  module: ModuleKey
  children: React.ReactNode
}) {
  const user = useAuthStore((s) => s.user)
  const role = useAuthStore((s) => s.role)
  if (!hasModuleAccess(user, role, module)) {
    return <ModuleLockedPage module={module} />
  }
  return <>{children}</>
}
